import React, { useMemo } from 'react';

import { getSafeNormalRange } from '../../utils';
import { optionsValues } from '../consts/options';
import BackButton from '../../../../common/BackButton';
import { useLabTestHistoryContext } from '../state/context';

import styles from './index.styl';

export const LabTestHistoryHeader = () => {
  const {
    data,
    name,
    close,
    setOption,
    setEndDate,
    setStartDate,
    formatMessage,
    getLabResultHistoryClear,
  } = useLabTestHistoryContext();
  const {
    graphAvailability = true,
    componentResultUnits = '',
    componentResultNormalRange = '',
  } = data[0] || '';

  const safeNormalRange = getSafeNormalRange(
    componentResultNormalRange,
    componentResultUnits,
  );

  const normalStateValue = useMemo(
    () => (componentResultNormalRange ? safeNormalRange : <span>&#8212;</span>),
    [componentResultNormalRange, safeNormalRange],
  );

  const handleBackButtonClick = () => {
    close();
    setEndDate('');
    setStartDate('');
    getLabResultHistoryClear();
    setOption(optionsValues.FIVE);
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.left}>
        <BackButton
          onBack={handleBackButtonClick}
          title={{ id: 'common.blank' }}
        />
        {name}
      </div>
      <div className={styles.right}>
        <div className={styles.rightTop}>
          {graphAvailability
            ? formatMessage({ id: 'patient.portal.labTestResult.normalRange' })
            : formatMessage({ id: 'patient.portal.labTestResult.normalState' })}
        </div>
        <div className={styles.rightBottom}>{normalStateValue}</div>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/PatientHealthboard/PatientPortal/LabTestHistoryModal/LabTestHistoryHeader/index.jsx